import { isValidElement } from 'react';
import { toast } from 'sonner';

function toMessageText(value, fallback = 'Não foi possível concluir a operação.') {
    if (isValidElement(value)) return value;
    let current = value;
    for (let depth = 0; depth < 5 && current && typeof current === 'object'; depth += 1) {
        current = current.message ?? current.description;
    }
    if (current == null || current === '') return fallback;
    return String(current);
}

export default function useClubErrors() {
    const enqueueSnackbar = (rawMessage, options = {}) => {
        const variant = options?.variant || 'default';
        const message = toMessageText(rawMessage);

        if (variant === 'error') {
            toast.error(message);
            return;
        }

        if (variant === 'warning') {
            toast.warning(message);
            return;
        }

        if (variant === 'info') {
            toast.info(message);
            return;
        }

        toast.success(message);
    };

    const setErrors = errors => {
        if (!errors) {
            enqueueSnackbar('Serviço indisponível', { variant: 'error' });
            return;
        }

        if (!errors.response) {
            enqueueSnackbar('Sistema sem resposta', { variant: 'error' });
            return;
        }

        const { status } = errors.response;

        if (status === 401) {
            if (errors.response.data?.error === 'refresh_token_reject') {
                enqueueSnackbar('Faça o login novamente.', { variant: 'error' });
            }
            return;
        }

        if (status === 404) {
            const apiMessage = errors.response.data?.message;
            enqueueSnackbar(
                typeof apiMessage === 'string' && apiMessage.trim()
                    ? apiMessage
                    : 'Caminho não encontrado',
                { variant: 'error' },
            );
            return;
        }

        if (errors.response.data) {
            if (Array.isArray(errors.response.data.message)) {
                errors.response.data.message.forEach(item => {
                    enqueueSnackbar(item.message, { variant: 'error' });
                });
                return;
            }

            if (errors.response.data.message) {
                enqueueSnackbar(errors.response.data.message, { variant: 'error' });
                return;
            }
        }

        if (errors.response.message) {
            enqueueSnackbar(errors.response.message, { variant: 'error' });
            return;
        }

        enqueueSnackbar('Servidor indisponível. Já estamos revisando!', { variant: 'warning' });
    };

    return { setErrors, enqueueSnackbar, toast };
}
